<template>
  <div class="dot-button" :class="[module_class]">
    <div class="ml-3 open-button" @click="toggle()">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>

      <div class="dropdown" v-show="open">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.module_class = 'dot-button-module-' + _.uniqueId()
  },
  mounted() {
      let button = document.getElementsByClassName(this.module_class)[0]
      button.addEventListener('mouseover', () => {
        this.mouse_over = true
      })
      button.addEventListener('mouseout', () => {
        this.mouse_over = false
      })
    document.addEventListener('click', () => {
      if (!this.mouse_over) {
        this.toggle(false)
      }
    })
  },
  data() {
    return {
      open: false,
      module_class: null,
    }
  },
  methods: {
    toggle(show = null) {
      if (show === null) {
        this.open = !this.open
      } else {
        this.open = show
      }
    },
  }
}
</script>
<style lang="scss">
.dot-button {
  .open-button {
    position: relative;
    width: 28px;
    height: 28px;
    border: 1px solid #D5D5D5;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    padding-top: 3px;

    .dot {
      margin-bottom: 3px;
      width: 3px;
      height: 3px;
      border: 1px solid black;
      background: black;
      border-radius: 100%;
    }

    .dropdown {
      background: white;
      border: 1px solid #D5D5D5;
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      min-width: 100px;
      position: absolute;
      top: calc(100% + 2px);
      left: 0;

      .dropdown-button {
        padding: 8px;

        &:hover {
          cursor: pointer;
          background: #F2F2F2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dot-button.vue